export default {
	template: `
		<div class="index-section index-section-placeholder">
			<span class="glyphicon glyphicon-plus"></span>
			グループを追加
		</div>
	`,

	mounted() {
	}
}
